import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';
const bookmarkSchema = t.object({
  path: t.string
});
export let BookmarkAction;
(function (BookmarkAction) {
  BookmarkAction["ADD"] = "ADD";
  BookmarkAction["REMOVE"] = "REMOVE";
})(BookmarkAction || (BookmarkAction = {}));
const bookmarkActionSchema = t.union(t.literal(BookmarkAction.ADD), t.literal(BookmarkAction.REMOVE));
const bookmarkChanged = defineMessage({
  type: 'bookmark-changed',
  payloadSchema: t.object({
    action: bookmarkActionSchema,
    success: t.boolean,
    bookmark: bookmarkSchema,
    failureReason: t.optional(t.string)
  })
});
const addBookmark = defineMessage({
  type: 'add-bookmark',
  payloadSchema: bookmarkSchema,
  reply: bookmarkChanged
});
const removeBookmark = defineMessage({
  type: 'remove-bookmark',
  payloadSchema: bookmarkSchema,
  reply: bookmarkChanged
});
const currentBookmarks = defineMessage({
  type: 'current-bookmarks',
  payloadSchema: t.array(bookmarkSchema)
});
const getCurrentBookmarks = defineMessage({
  type: 'get-current-bookmarks',
  reply: currentBookmarks
});
export const bookmarksApi = {
  addBookmark,
  removeBookmark,
  getCurrentBookmarks,
  currentBookmarks,
  bookmarkChanged
};